"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _viewBox = _interopRequireDefault(require("./viewBox"));
var _addBox = _interopRequireDefault(require("./addBox"));
var _notOnItemOverlay = _interopRequireDefault(require("./notOnItemOverlay"));
var _unavailableForItemOverlay = _interopRequireDefault(require("./unavailableForItemOverlay"));
var _customisationModule = _interopRequireDefault(require("./customisation.module.scss"));
require("../../style/animations.scss");
var _icon = _interopRequireDefault(require("../../icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var CustomisationCard = function CustomisationCard(props) {
  //set the correct mode
  var mode = props.id > 0 ? "view" : "add";
  var ViewNodeRef = /*#__PURE__*/_react["default"].createRef();
  var AddNodeRef = /*#__PURE__*/_react["default"].createRef();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_customisationModule["default"].container, " ").concat(props.extendedDetails && _customisationModule["default"].extended),
    "data-testid": "customisation-card"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    key: "view",
    nodeRef: ViewNodeRef,
    "in": mode === "view",
    timeout: 200,
    appear: true,
    classNames: "transition-fade",
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(_viewBox["default"], _extends({
    ref: ViewNodeRef
  }, props))), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    key: "add",
    nodeRef: AddNodeRef,
    "in": mode === "add",
    timeout: 200,
    appear: true,
    classNames: "transition-fade",
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(_addBox["default"], _extends({
    ref: AddNodeRef
  }, props))), /*#__PURE__*/_react["default"].createElement(_notOnItemOverlay["default"], props), /*#__PURE__*/_react["default"].createElement(_unavailableForItemOverlay["default"], props));
};
CustomisationCard.propTypes = {
  count: _propTypes["default"].number,
  id: _propTypes["default"].number,
  name: _propTypes["default"].string,
  type: _propTypes["default"].string,
  position: _propTypes["default"].string,
  width: _propTypes["default"].number,
  extendedDetails: _propTypes["default"].bool,
  transparent: _propTypes["default"].bool,
  paidStatus: _propTypes["default"].bool,
  redrawService: _propTypes["default"].bool,
  canEdit: _propTypes["default"].bool,
  canDelete: _propTypes["default"].bool,
  canAdd: _propTypes["default"].bool,
  canRemove: _propTypes["default"].bool,
  onItem: _propTypes["default"].bool,
  onNew: _propTypes["default"].func,
  onClose: _propTypes["default"].func,
  onEdit: _propTypes["default"].func,
  onAdd: _propTypes["default"].func,
  onDelete: _propTypes["default"].func
};
CustomisationCard.defaultProps = {
  count: 1,
  id: null,
  name: "",
  type: "Printed logo",
  position: null,
  width: 5,
  active: true,
  extendedDetails: false,
  transparent: true,
  paidStatus: false,
  redrawService: false,
  canEdit: false,
  canAdd: false,
  canRemove: false,
  onItem: true,
  onNew: null,
  onClose: null,
  onEdit: null,
  onAdd: null,
  onDelete: null
};
var _default = exports["default"] = CustomisationCard;